import React from 'react'

const Manual_admin_faceid_empleados = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Admin - FaceID para Empleados
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía explica cómo cargar una foto compatible con FaceID, detallando los requisitos de formato, dimensiones y calidad para evitar errores y garantizar una identificación sin problemas.
        </p>
        <iframe
          src="https://scribehow.com/embed/Admin__FaceID_para_Empleados__Z8Sx_rprRB2OyKGME3Ywlg?as=scrollable"
          className="scribe-iframe-general-170"
          width="100%"
          height="3800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_admin_faceid_empleados